export default {"src":"/_next/static/media/customer-airbnb.5be9c1ed.svg","height":780,"width":2500};